import Lottie from 'lottie-react'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import * as PaymentSuccessAnimation from '../../assets/animations/payment-success.json'
import PaperEffect from '../../assets/images/bill-paper-bottom.png'
import FlowerGreen from '../../assets/images/flower-green.webp'
import Button from '../../components/atoms/GoodFlipButton'
import ArrowIcon from '../../components/atoms/Arrow'
import Text from '../../components/atoms/Text'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { formatCurrency } from '../../utils/helpers/common'

const SuccessPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { state } = location
  const { formFields } = useSelector((s) => s.formPayload)

  const formatTimeRange = (timeRange) => {
    const [start, end] = timeRange.split(' - ')
    const startMoment = moment(start, 'HH:mm')

    return `${startMoment.format('hh:mm A')}`
  }

  return (
    <section className="bg-text-success-primary h-screen w-screen relative overflow-hidden">
      <img
        src={FlowerGreen}
        alt="flower"
        className="h-52 w-52 absolute -left-[100px] z-0"
        style={{ top: 'calc(50% - 100px)' }}
      />
      <img
        src={FlowerGreen}
        alt="flower"
        className="h-52 w-52 absolute -right-[100px] z-0"
        style={{ top: 'calc(50% - 100px)' }}
      />
      <div className="p-11 w-full flex flex-col relative justify-center h-screen max-w-lg lg:max-w-xl mx-auto">
        <div className="h-[100px] w-[100px] self-center rounded-full bg-WHITE flex items-center justify-center shadow-2xl z-10">
          <Lottie
            animationData={PaymentSuccessAnimation}
            autoplay
            loop
            className="h-full w-full"
          />
        </div>
        {/* Program Details */}
        <div className="bg-WHITE w-full rounded-t-2xl -mt-[50px] pt-[56px] px-3 pb-4">
          <div className="flex flex-col gap-1 py-2">
            <Text
              tag="p"
              variant="title"
              size="medium"
              className="text-text-primary"
              textalign="center"
            >
              Lab Test Slot Booked
            </Text>
            <Text
              tag="p"
              variant="label"
              size="medium"
              className="text-text-quartenary"
              textalign="center"
            >
              Booked For:{' '}
              <Text
                tag="span"
                variant="label"
                size="medium"
                bold={'true'}
                className="text-text-quartenary"
                textalign="center"
              >
                {formatTimeRange(state.cartData?.slot_time)},{' '}
                {moment(state.cartData?.appointment_date).format(
                  'DD MMM YYYY (dddd)',
                )}
              </Text>
            </Text>
          </div>
          <div className="flex flex-row items-center gap-1 mt-2 mb-3">
            <Text
              tag="p"
              variant="label"
              size="small"
              className="whitespace-nowrap text-text-quartenary"
            >
              Address Details
            </Text>
            <div className="h-[1px] w-full bg-border-secondary" />
          </div>
          <div>
            <Text
              tag="p"
              variant="label"
              size="medium"
              className="text-text-quartenary"
            >
              {formFields?.addressPayload?.address},{' '}
              {formFields?.addressPayload?.landmark},{' '}
              {formFields?.addressPayload?.street},{' '}
              {formFields?.addressPayload?.pincode}
            </Text>
          </div>
        </div>
        <div className="bg-white flex items-center justify-center py-2">
          <div className="p-2 bg-background-accent-teal rounded-full ring-4 ring-[#F2F4F7]">
            <Text
              tag={'p'}
              variant={'label'}
              size={'medium'}
              className={'text-text-quartenary'}
            >
              Amount Paid:{' '}
              <Text
                tag={'span'}
                variant={'label'}
                size={'medium'}
                bold={'true'}
                className={'text-text-quartenary'}
              >
                {formatCurrency(599)}
              </Text>
            </Text>
          </div>
        </div>
        <img src={PaperEffect} alt="paper" className="w-full h-6" />
        <div className="w-0 h-12 border-dashed border-WHITE border-[1px] self-center my-2" />
        {/* Next Steps */}
        <div>
          <div className="flex items-center gap-3 bg-WHITE rounded-2xl overflow-hidden p-2.5">
            <div className="">
              <Text
                tag="p"
                variant="label"
                size="medium"
                className="text-text-quartenary"
              >
                Next Steps
              </Text>
              <Text
                tag="p"
                variant="label"
                size="medium"
                className="text-text-primary"
              >
                Sit back and relax, our experts will collect your blood sample
                at the mentioned address
              </Text>
            </div>
          </div>
        </div>

        <div className="px-3 py-7 flex items-start">
          <div className="w-10 h-8">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M8 1.33301C4.32666 1.33301 1.33333 4.32634 1.33333 7.99967C1.33333 11.673 4.32666 14.6663 8 14.6663C11.6733 14.6663 14.6667 11.673 14.6667 7.99967C14.6667 4.32634 11.6733 1.33301 8 1.33301ZM7.5 5.33301C7.5 5.05967 7.72666 4.83301 8 4.83301C8.27333 4.83301 8.5 5.05967 8.5 5.33301V8.66634C8.5 8.93967 8.27333 9.16634 8 9.16634C7.72666 9.16634 7.5 8.93967 7.5 8.66634V5.33301ZM8.61333 10.9197C8.58 11.0063 8.53333 11.073 8.47333 11.1397C8.40666 11.1997 8.33333 11.2463 8.25333 11.2797C8.17333 11.313 8.08666 11.333 8 11.333C7.91333 11.333 7.82666 11.313 7.74666 11.2797C7.66666 11.2463 7.59333 11.1997 7.52666 11.1397C7.46666 11.073 7.41999 11.0063 7.38666 10.9197C7.35333 10.8397 7.33333 10.753 7.33333 10.6663C7.33333 10.5797 7.35333 10.493 7.38666 10.413C7.41999 10.333 7.46666 10.2597 7.52666 10.193C7.59333 10.133 7.66666 10.0863 7.74666 10.053C7.90666 9.98634 8.09333 9.98634 8.25333 10.053C8.33333 10.0863 8.40666 10.133 8.47333 10.193C8.53333 10.2597 8.58 10.333 8.61333 10.413C8.64666 10.493 8.66666 10.5797 8.66666 10.6663C8.66666 10.753 8.64666 10.8397 8.61333 10.9197Z"
                fill="white"
              />
            </svg>
          </div>
          <Text
            tag="p"
            variant="label"
            size="medium"
            className="text-text-primary-on-brand ml-1 italic"
          >
            Invoice for this purchase is shared via WhatsApp on the registered
            mobile number
          </Text>
        </div>
      </div>
      <div className="fixed bottom-0 left-0 right-0 bg-[rgba(255,_255,_255,_0.85)] pb-4 pt-2 z-10">
        <div className="max-w-lg lg:max-w-xl mx-auto">
          <Button
            onClick={() => navigate('/', { replace: true })}
            title={'Back To Home'}
            type="goodflip_primary"
            leftIcon={null}
            rightIcon={<ArrowIcon direction="right" color="#FFFFFF" />}
          />
        </div>
      </div>
    </section>
  )
}

export default SuccessPage
